import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Data passed into the SERPRO name confirmation modal. */
export interface SerproNameConfirmData {
  /** The name the user provided (cp_pii.legal_name). May be null/blank. */
  currentName: string | null;
  /** The authoritative SERPRO name to accept. */
  serproName: string;
  /** Optional document label for context. */
  documentTitle?: string;
}

/** Result returned when the modal closes. */
export interface SerproNameConfirmResult {
  /** true = accept the SERPRO name and proceed; false = reject (KYC fails). */
  accept: boolean;
}

/**
 * 🇧🇷 SERPRO name gate modal. Shown when the authoritative SERPRO (CPF) name does
 * not match the name the user provided, BEFORE the Veriff document step. The user
 * accepts the SERPRO name (and the flow continues) or rejects it (the KYC fails
 * and they must restart with correct details). Pure UI — the parent performs the
 * network call with the returned decision.
 */
@Component({
  selector: 'app-serpro-name-confirm-modal',
  templateUrl: './serpro-name-confirm-modal.component.html',
  styleUrls: ['./serpro-name-confirm-modal.component.scss'],
})
export class SerproNameConfirmModalComponent {
  /** Locks the buttons once a choice is made (prevents double submit). */
  saving = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SerproNameConfirmData,
    private dialogRef: MatDialogRef<SerproNameConfirmModalComponent, SerproNameConfirmResult>
  ) {}

  accept(): void {
    if (this.saving) return;
    this.saving = true;
    this.dialogRef.close({ accept: true });
  }

  reject(): void {
    if (this.saving) return;
    this.saving = true;
    this.dialogRef.close({ accept: false });
  }
}
